import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import {
  checklistCompletedOption,
  machineList,
  speciesOptions,
  vehicalCheckListOption,
  yesNoOption,
} from '../Data/HFDropDowdData';
import { harvestingMaintanceVehicalCheckListoptionList, vehicalInspectionList } from '../Data/HfInputFieldsData';
import SectionAccordians from 'routes/Pages/components/Accordians/SectionAccordians';
import DetailedM3Table from './DetailedM3Table';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';
const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};
const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};
const HFStockTakeForm = ({ stockTakeData, setStockTakeData, spList, spListObj, productionData, setProductionData }) => {
  const handleChangeData = (name, value) => {
    let updatedData = {
      [name]: value,
    };

    setStockTakeData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={stockTakeData['employeeName']} onChange={handleChangeData} isOperator={true} />
      <InputFields
        label="Date & Time"
        helperText={'Enter Clock in Date & Time'}
        name="date_Time"
        required={true}
        value={stockTakeData['date_Time']}
        textFieldType={'datetime-local'}
        width={4}
        handleIpChange={handleChangeData}
      />

      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Forest or SP Number
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'forestSPNumber'}
          value={stockTakeData['forestSPNumber'] || null}
          options={spListObj ? Object.keys(spListObj) : []}
          onChange={(event, newValue) => handleChangeData('forestSPNumber', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={4}>
        <InputLabel size="small" sx={dropDownStyles} required>
          Species
        </InputLabel>

        <Autocomplete
          size="small"
          disablePortal
          name={'species'}
          value={stockTakeData['species'] || null}
          options={speciesOptions}
          onChange={(event, newValue) => handleChangeData('species', newValue)}
          sx={{ fontSize: '0.8rem' }}
          renderInput={params => <TextField required {...params} size="small" fullWidth />}
          fullWidth
          slotProps={{
            ...autoCompleteSlotProps,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <DetailedM3Table 
          productionData={productionData} 
          setProductionData={setProductionData} 
          currDailyHarvestingData={stockTakeData}
          handleChangeDailyHarvestingData={handleChangeData}
        />
      </Grid>

      <InputFields
        label="Additional Information"
        name="additionalInformation"
        value={stockTakeData['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={12}
        handleIpChange={handleChangeData}
      />
    </Grid>
  );
};

export default HFStockTakeForm;
